import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import { store } from './app/store';
import { theme } from "./assets/styles/theme";
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root') || document.createElement('div');
const root = createRoot(container);

root.render(
   <React.StrictMode>
      <Router>
         <Provider store={store}>
            <ThemeProvider theme={theme}>
               <App />
            </ThemeProvider>
         </Provider>
      </Router>
   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
